import { CanMatchFn } from '@angular/router';
import { FeatureFlags } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';

/**
 * Route guard protecting the gantt chart routes (private and public) with the gantt.chart feature flag.
 * Returning false lets the router fall through to the wildcard not-found route.
 */
export const ganttChartRouteGuard: CanMatchFn = () => {

  return ConfigService.environment.featureFlags?.[FeatureFlags.GanttChart] ?? false;
};
